<template>
  <!-- The paper plane of Telegram, drawn in the text colour. -->
  <svg viewBox="0 0 24 24" width="1.2em" height="1.2em" fill="currentColor" aria-hidden="true" focusable="false">
    <path d="M21.9 3.4 2.6 10.8c-.8.3-.8 1.3 0 1.6l4.7 1.5 1.8 5.6c.2.6 1 .8 1.4.3l2.6-2.5 4.9 3.6c.5.4 1.3.1 1.4-.6l3-15.8c.2-.8-.6-1.4-1.5-1.1ZM9.6 13.6l8.7-5.4c.2-.1.3.1.2.3l-7.2 6.6-.3 3.2-1.4-4.7Z" />
  </svg>
</template>
